<template>
    <v-card>

        <v-toolbar dark dense class="elevation-0">
            <v-toolbar-title card color="secondary">
                <v-icon> mdi-account-multiple</v-icon>
                Πελάτες στην Βάση
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-card color="black" dark>
            <v-list dense  @click="">
                <v-list-tile @click="filterRelations(admin)">
                    <v-list-tile-avatar>
                        <v-icon> mdi-account</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title> admin
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-card>
        <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
        ></v-text-field>
        <v-data-iterator
                :search="search"
                :items="b2b.customers"
                row
                wrap
                hide-actions
                class="boxes-front scroll-y"
                :rows-per-page-items="[-1]"
                content-tag="v-layout"
        >
            <v-flex
                    lg12
                    slot="item"
                    slot-scope="props"
            >
                <v-list dense v-if="props.item.ID!=='admin'">
                    <v-list-tile @click="" ripple>
                        <v-list-tile-content
                                @click="filterRelations(props.item.ID)"
                        >
                            <v-list-tile-title> ID:{{props.item.ID}} {{ props.item.Name }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action class="pl-0">
                            <v-menu
                                    :close-on-content-click="false"
                                    :nudge-width="200"
                                    offset-x
                            >
                                <v-btn
                                        class="pa-0"
                                        fab
                                        flat
                                        color="secondary"
                                        small dark
                                        slot="activator"
                                        dark
                                >
                                    <v-icon> mdi-chevron-down</v-icon>
                                </v-btn>
                                <v-card>
                                    <v-list>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    {{props.item.Name}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                    <v-divider></v-divider>
                                    <v-list>
                                        <v-list-tile ripple
                                                     color=""
                                                     :to="'customer/'+props.item.ID">

                                            <v-list-tile-content>
                                                Λεπτομέρειες Πελάτη
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon> mdi-account </v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                    <v-list>
                                        <v-list-tile ripple
                                                     color="error"
                                                     @click="deleteCustomer( props.item.ID)">

                                            <v-list-tile-content>
                                                Διαγραφή
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="error"> mdi-key-remove</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                    <v-divider></v-divider>
                                </v-card>
                            </v-menu>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                </v-list>
            </v-flex>

        </v-data-iterator>
    </v-card>
</template>

<script>
    import StoreState from "@/assets/StoreState";
    import ApiData from "../assets/ApiData";

    export default {
        name: "Customers",
        data: () => ({
            b2b: StoreState.b2b,
            rowsPerPageItems: [10, 15, 25],
            pagination: {
                rowsPerPage: 10
            },
            search:'',
            admin: ApiData.admin,
        }),
        methods: {
            filterRelations(customerID) {
                StoreState.filterRelations({customerID: customerID})
            },
            deleteCustomer(id) {
                if (!window.confirm("Η ενέργεια αυτή θα διαγράψει τον πελάτη, αλλά και τις προσβάσεις που έχει σε προσφορές, είτε σίγουροι;")) return;
                StoreState.messages.isLoading = true;
                ApiData.deleteCustomer(id).then(
                    resp => {
                        if (resp) {
                            StoreState.deleteCustomer(id);
                            this.$notify({
                                group: 'messages',
                                type: 'success',
                                text: 'Αποθηκεύτηκε'
                            });
                        }
                        StoreState.messages.isLoading = false;
                    }
                ).catch(err => {
                    this.$notify({
                        group: 'messages',
                        type: 'success',
                        text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση'
                    });
                    StoreState.messages.isLoading = false;
                    StoreState.messages.error = err;
                });
            },
        }
    }
</script>

<style scoped>
    .scroll-y{
        overflow: auto;
    }
    .boxes-front{
        max-height: 50vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Customers.vue